import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import MUISelect, { SelectChangeEvent } from '@mui/material/Select';

export type ItemsProps = {
    text?: string;
    value: string | number;
    id: number;
    category?: string;
};

export type SelectProps = {
    items: ItemsProps[];
    value: string;
    onChange: (e: SelectChangeEvent) => void;
    name: string;
    label: string;
};

const Select = ({ items, name, value, onChange, label }: SelectProps) => {
    return (
        <MUISelect name={name} label={label} onChange={onChange} value={value}>
            {items.map((item) => {
                return (
                    <MenuItem value={item.value} key={item.id} style={{ whiteSpace: 'normal' }}>
                        {item.text}
                    </MenuItem>
                );
            })}
        </MUISelect>
    );
};

export default Select;
